module.exports = __webpack_public_path__ + "img/profile-back.19990f6.png";